import React, { createContext } from "react";

// 다이얼로그 타입 정의
export type DialogType = "alert" | "confirm";

type Type = {
    confirm: (message?: string) => Promise<boolean>;
    showPopup: (
        title: string,
        options?: {
            highlightText?: string;
            type?: DialogType;
            onConfirm?: () => void;
        }
    ) => Promise<boolean>;
};

const ConfirmContext = createContext<Type>({
    confirm: () => new Promise((_, reject) => reject()),
    showPopup: () => new Promise((_, reject) => reject())
});

export default ConfirmContext;
